import { render, staticRenderFns } from "./cameraPicture.vue?vue&type=template&id=b2573332&scoped=true"
import script from "./cameraPicture.vue?vue&type=script&lang=js"
export * from "./cameraPicture.vue?vue&type=script&lang=js"
import style0 from "./cameraPicture.vue?vue&type=style&index=0&id=b2573332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2573332",
  null
  
)

export default component.exports